export class FilesUtil {
  public static readonly IMAGE_ACCEPT_FORMATS: string = 'image/png, image/jpg';

  public static get MAX_FILE_SIZE() {
    return 800 * 1024;
  }

  public static isFilesSizeValid(files: FileList | null): boolean {
    return !!(files && files.length > 0);
  }
}
